<template>
    <div>
        <div class="row" v-if="treeServiceCategories.length > 0">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="provider_type"> {{ trans('providerController.service_types') }}</label>
                    <input type="text" name="provider_type" id="provider_type" value="" style="display:none;">
                    <v-app>
                        <v-treeview
                            :open="open"
                            :items="treeServiceCategories"
                            item-children="nodes"
                            item-text="text"
                            item-key="href"
                            v-model="vehicleModel.provider_type"
                            selection-type="independent"
                            selectable
                            return-object
                            hoverable
                        ></v-treeview>
                    </v-app>
                    <span v-html="errorNotFoundProviderType"></span>
                </div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="car_number">{{ trans('providerController.vehicle_plate') }}</label>
                    <div class="input-group">
                        <input
                            v-if="(carPlateMask instanceof String  && carPlateMask.length > 0)"
                            type="text"
                            class="form-control"
                            name="car_number"
                            data-test="car_number"
                            id="car_number"
                            maxlength="15"
                            v-mask="carPlateMask"
                            :placeholder="trans('providerController.vehicle_plate')"
                            v-model="vehicleModel.car_number"
                            data-error="provider.car_plate_message"
                        >
                      <input
                            v-else
                            type="text"
                            class="form-control"
                            name="car_number"
                            data-test="car_number"
                            id="car_number"
                            maxlength="15"
                            :placeholder="trans('providerController.vehicle_plate')"
                            v-model="vehicleModel.car_number"
                            data-error="provider.car_plate_message"
                        >
                        <div class="input-group-addon"><span class="fa fa-car"></span></div>
                    </div>
                    <div class="help-block with-errors"></div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="car_brand">{{trans('providerController.vehicle_brand') }}</label>
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            name="car_brand"
                            data-test="car_brand"
                            id="car_brand"
                            maxlength="15"
                            :placeholder="trans('providerController.vehicle_brand')"
                            v-model="vehicleModel.car_brand"
                            data-error="provider.car_brand_message"
                        >
                        <div class="input-group-addon"><span class="fa fa-car"></span></div>
                    </div>
                    <div class="help-block with-errors"></div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="car_model">{{ trans('providerController.vehicle_model') }}</label>
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control"
                            name="car_model"
                            data-test='car_model'
                            id="car_model"
                            maxlength="15"
                            placeholder="Modelo do veículo"
                            v-model="vehicleModel.car_model"
                            data-error="provider.car_model_message"
                        >
                        <div class="input-group-addon"><span class="fa fa-car"></span></div>
                    </div>
                    <div class="help-block with-errors"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Vuetify from 'vuetify';
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import axios from 'axios';
import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/index.css';
import VueTheMask from 'vue-the-mask';
Vue.use(VueTheMask)
Vue.use(Vuetify);

Vue.use(VueFormWizard);

export default {
    components: { Multiselect, DatePicker },
    props: {
        vehicleModel: Object,
        base_url: String,
        carPlateMask: String,
        providerId: Number | String,
        treeServiceCategories: Array,
    },
	vuetify: new Vuetify(),
    data() {
        return {
            selectedServices: [],
			open: [],
            errorNotFoundProviderType: "",
			lang: "pt-br"
        }
    },
    methods: {
        validate() {
            var valid = true;

            if (this.treeServiceCategories.length > 0) {
                if (this.vehicleModel.provider_type.length > 0) {
                    this.errorNotFoundProviderType = "";

                    this.treeServiceCategories.forEach(element => {
                        if (this.vehicleModel.provider_type.includes(element)) {
                            element.state = { selected: true };
                        } else {
                            element.state = { selected: false };
                        }
                        if (element.nodes) {
                            element.nodes.forEach(category => {
                                if (this.vehicleModel.provider_type.includes(category)) {
                                    category.state = { selected: true };
                                } else {
                                    category.state = { selected: false };
                                }
                            });
                        }
                    });
                } else {
                    this.errorNotFoundProviderType =
                        '<div class="help-block with-errors"><span>' + this.trans('user_provider_controller.select_service') + '</span></div>';
                    valid = false;
                }
            }

            return valid;
        },
        async save() {
            Swal.fire({
                text: this.trans('providerController.saving_vehicle_info'),
            });
            Swal.showLoading();

            var formData = new FormData();
			formData.append('origin', 'web');

            if (this.providerId)
			    formData.append('provider', this.providerId);

            for (var key in this.vehicleModel) {
                var value = this.vehicleModel[key];
                if (key == 'provider_type')
                    value = JSON.stringify(this.treeServiceCategories);
                formData.append(key, value);
            }

            try {
                var json_result = await axios.post(this.base_url + '/api/v2/provider/wizard/save_vehicle', formData,
                {
                    crossDomain: true,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
            
                if (json_result.data.success == true) {
                    this.providerId = json_result.data.provider.id;
                    Swal.close();
                    return true;
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: json_result.data.errors,
                    });
                    
                    return false;
                }
            } catch(error) {
                alert(error);
                Swal.close();
                return false;
            }
        }
    },
    mounted() {},
    created() {}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./register.css"></style>
<style>
@import "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900";
@import "https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css";
@import "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css";
</style>